import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';
import { OrderingMarketplace } from './useGetSettings';

interface QuotePart {
    _id: string;
    title: string;
    partNumber: string;
    emsPartType: string;
    excludeQuoting?: boolean;
    manualFlag?: boolean;
}

interface QuoteDataResponse {
    parts: Array<QuotePart>;
    orderId: string;
    roNumber: string;
    needsPartTypeVerification: boolean;
    allowExpedited: boolean;
    allowDealerReferral: boolean;
    oemCertification: boolean;
    locationName: string;
    preferredDeliveryTimePreference: number;
    isCustomerPayOrder: boolean;
    disableAutoOrderCustomerPay: boolean;
    orgAllowAutoOrder: boolean;
    allowScheduled: boolean;
    canDisableAutoOrder: boolean;
    enforceOemEndorsement: boolean;
    enforceOemEndorsementReason: string | null;
    marketplaces: Array<OrderingMarketplace | 'tesla'>;
    canQuote: boolean;
    canSkipQuote: boolean;
}

const getQuoteData = async (sessionId: string, orderId: string, resubmit?: boolean): Promise<QuoteDataResponse> => {
    const { data } = await axios.get(
        `${API_URL}/order/quote`,
        {
            params: { orderId, resubmit },
            headers: {
                Authorization: sessionId
            }
        }
    );
    return data;
};

export const useGetQuoteData = (orderId: string | null, resubmit: boolean) => {
    const sessionContext = useContext(SessionContext);

    return useQuery({
        queryKey: ['quoteData', orderId],
        queryFn: () => getQuoteData(sessionContext?.sessionId ?? '', orderId!, resubmit),
        enabled: !!orderId && !!sessionContext?.sessionId,
    });
};
